/** This package's version, sent as `x-v5-client` on every call. A test holds it to package.json. */
export const CLIENT_VERSION = "0.1.0";
/** The request header that names the packaged client and its version (V6 plan 13.3.1). */
export const CLIENT_HEADER = "x-v5-client";
/** The response header that names the wire version the server speaks (H.14), when it sends one. */
export const API_VERSION_HEADER = "v5-api-version";
//# sourceMappingURL=version.js.map